export default "__VITE_ASSET__04800916__"